import React, { Fragment } from "react";
import stringifyBit from "../../bitTextParser";
import { GambitTooltip } from "../../Gambit";
import { styleClassName } from "../../styleHelper";
import { IChoice, SelectionChoicesProps } from "../types";
import "./index.css";

const containerClassName = styleClassName(
  "nes-container with-title is-centered"
);

/**
 * 0 Height elements to cleanly align items
 * Note: There is nothing unique about each item
 */
function EmptyFix() {
  return (
    <>
      {Array(6)
        .fill(null)
        .map((_, i) => (
          /* eslint-disable react/no-array-index-key */
          <span key={`empty-${i}`} className="empty-choice" />
        ))}
    </>
  );
}

const generateKey = (choice: IChoice) => {
  if (!("left" in choice)) return choice.key;
  const { left, key, right } = choice;
  return `${left}-${key}-${right}`;
};

function SelectionChoice(choice: IChoice, setPick: (choice: IChoice) => void) {
  const key = generateKey(choice);
  const tooltipId = `${key}-tooltip`;
  return (
    <Fragment key={key}>
      <button
        type="button"
        className="choice nes-btn"
        onClick={() => setPick(choice)}
        data-tip=""
        data-for={tooltipId}
      >
        {stringifyBit(choice)}
      </button>
      {choice.type === "magic" && (
        <GambitTooltip id={tooltipId} action={choice} />
      )}
    </Fragment>
  );
}

export default function SelectionChoices({
  text,
  choices = [],
  setPick,
  filter
}: SelectionChoicesProps) {
  const dataFilter = (choice: IChoice) =>
    stringifyBit(choice)
      .toUpperCase()
      .includes(text.toUpperCase());
  const filteredChoices = choices.filter(dataFilter).filter(filter);

  return (
    <div id="selection-choices" className={containerClassName}>
      <div className="wrapper">
        {filteredChoices.map(choice => SelectionChoice(choice, setPick))}
        <EmptyFix />
      </div>
    </div>
  );
}
